<template>
  <div class="about">
    <h1>121313331321</h1>
  </div>
</template>

<script>
export default {
  name: "about",
  components: {}
};
</script>
